<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div @click="goTitlePage('Summary')"  class="title d-sm-flex pointer" :class="{'active' : title === 'Summary'}">
            <div class="my-auto">
              {{ copy.courseOverview }}
            </div>
          </div>
          <div @click="goTitlePage('Info')" class="title  d-sm-flex pointer" :class="{'active' : title === 'Info'}">
            <div class="my-auto">
              {{ copy.learningRecords }}
            </div>
          </div>
          <div @click="goTitlePage('Curve')" class="title  d-sm-flex pointer" :class="{'active' : title === 'Curve'}">
            <div class="my-auto">
              {{ copy.learningCurve }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-2" style="min-height:40vh">
        <div class="d-flex align-items-center">
          <label class="m-0 mr-2">{{ copy.studentName }}:</label>
          <v-select style="width:200px" :clearable="false" v-model="studentId" :reduce="name => name.id" :get-option-label="displayName" :options="studentList">
            <span slot="no-options">
              {{ copy.noResults }}
            </span>
          </v-select>
        </div>
        <div class="my-2">
          <div class="d-flex align-items-center">
            <label class="m-0 mr-2">{{ copy.dateRange }}:</label>
            <date-picker :clearable="false" valueType="format" v-model="range" type="date" range :placeholder="copy.selectDateRange"></date-picker>
          </div>
        </div>
        <div style="margin:100px" v-if="datasets">
          <LineChart :height="250" :datasets="datasets" class="mt-3 m-auto" />
        </div>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import LineChart from '../LineChart.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import api from '../../store/api'
export default {
  name: 'Curve',
  data () {
    return {
      studentList: [],
      studentId: null,
      pageIndex: 1,
      pageCount: 0,
      range: ['' , ''],
      datasets: null,
      title: 'Curve'
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          courseOverview: '課程總覽',
          learningRecords: '學習紀錄',
          learningCurve: '學習曲線',
          studentName: '學員姓名',
          noResults: '找不到搜尋結果',
          dateRange: '日期區間',
          selectDateRange: '請選擇日期區間'
        },
        en: {
          courseOverview: 'Course Overview',
          learningRecords: 'Learning Records',
          learningCurve: 'Learning Curve',
          studentName: 'Student Name',
          noResults: 'No results found',
          dateRange: 'Date Range',
          selectDateRange: 'Select a date range'
        }
      }

      return copy[this.currentLocale] || copy.tw
    },
    groupId () {
      return this.$route.params.groupId
    },
    lessonId () {
      return this.$route.params.lessonId
    }
  },
  components: {
    DatePicker,
    LineChart
  },
  watch: {
    studentId (val) {
      if (val !== null) {
        this.getCurveData()
      }
    },
    range (val) {
      console.log(val)
      if (this.studentId !== null) {
        this.getCurveData()
      }
    }
  },
  async mounted () {
    await this.getRange()
    await this.getStudentList()
    await this.getCurveData()
  },
  methods: {
    async getStudentList() {
      const params = {
        page: this.pageIndex,
        pageSize: 50
      }
      const { data } = await api.get(`groups/${this.groupId}/students`, { params })
      this.studentList = data.data
      this.studentId = data.data[0].id
      this.page = data.pageIndex
      this.pageCount = data.pageCount
    },
    async getRange () {
      const self = this
      this.range = [self.moment(this.$store.state.auth.user.group_begin_at).format('YYYY-MM-DD'), self.moment(this.$store.state.auth.user.group_end_at).format('YYYY-MM-DD')]
    },
    goTitlePage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    },
    displayName (item) {
      if (!item) {
        return ''
      }

      if (this.currentLocale === 'en') {
        return item.name_en || item.display_name || item.name || ''
      }

      return item.name || item.display_name || item.name_en || ''
    },
    async getCurveData() {
      const { data } = await api.get(`records/students/${this.studentId}/speak_growing_avg?begin=${this.range[0]}&end=${this.range[1]}`)
      const date = Object.values(data.data).map(item => item.date)
      const score = Object.values(data.data).map(item => item.score)
      console.log(data.data)
      this.datasets = {
        labels: date,
        datasets: [
          {
            label: '',
            borderColor: '#f87979',
            data: score,
            fill: false
          }
        ]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/color.scss";
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .active {
    // color: red;
    font-weight: bolder;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
